export default {"src":"/_next/static/media/content_quiz_self_assessment_test_1.cbd36b4a.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};